import axios from 'axios';
import {
    Message
} from 'element-ui';

const service = axios.create({
    baseURL: '',
    // 超时
    timeout: 50000,
    // post系列data处理
    transformRequest(data) {
        data = JSON.stringify(data);
        return data;
    },
    // 是否携带跨域资源凭证
    withCredentials: true,
});
service.defaults.headers['Content-Type'] = 'application/json';
// 请求拦截
service.interceptors.request.use(
    config => {
        // 发送请求之前做处理，可以处理token
        let info = JSON.parse(localStorage.getItem('userInfo'));
        if (info) {
            config.headers.accessToken = info.accessToken
        }
        return config;
    },
    err => {
        Message({
            message: "请求失败",
            type: "error",
            duration: 2000
        });
        return Promise.reject(err);
    }
);
// 响应拦截
service.interceptors.response.use(
    res => {
        const code = res.data.code || 0;
        const msg = res.data.msg;
        // if (code && code !== 0) {
        //     Message({
        //         message: '业务异常',
        //         type: 'error'
        //     });
        //     return Promise.reject(msg)
        // };
        return res.data;
    },
    err => {
        Message({
            message: '请求失败',
            type: 'error'
        });
        return Promise.reject(err);
    }
);

export default service;


// WEBPACK FOOTER //
// ./src/api/axios.js